import type {ButtonHTMLAttributes} from 'react';
import {Button} from '@platform/ui/Button';
import {useCopy} from '@platform/ui/config';
import './QuickSelectionButton.css';

export function QuickSelectionIcon(){
 return <svg className="room-quick-icon" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="m10 2 2.7 6.3L19 11l-6.3 2.7L10 20l-2.7-6.3L1 11l6.3-2.7Z"/><path d="m20 1 1.1 2.9L24 5l-2.9 1.1L20 9l-1.1-2.9L16 5l2.9-1.1Zm0 14 1.1 2.9L24 19l-2.9 1.1L20 23l-1.1-2.9L16 19l2.9-1.1Z"/></svg>;
}

// The catalogue owns this control; its icon is also reused by the next-draw action.
export function QuickSelectionButton({label,className='',...props}:Omit<ButtonHTMLAttributes<HTMLButtonElement>,'children'> & {label?:string}){
 const t=useCopy(),text=label??t('room.quick');
 return <Button aria-label={text} title={text} aria-haspopup="dialog" {...props} className={'room-quick '+className}>
  <QuickSelectionIcon/>
  <span>{text}</span>
 </Button>;
}
